import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import TableRow from "@mui/material/TableRow";
import IntervalSetSaveButton from "./controls/widgets/IntervalSetSaveButton";
import { MatrixHeadingControlsRowProps } from "./MatrixCommSetsControlsRow";

export const MatrixHeadingControlsRowStyled = styled(TableRow)(({ theme }) => ({
  div: {
    backgroundColor: "white",
    padding: "0px",
  },
}));


const MatrixBottomControlsRow = (props: MatrixHeadingControlsRowProps) => {

  return (
    <div style={{ height: "50px", padding:"10px" }}>
        {props.changesDetected && <IntervalSetSaveButton handler={props.intervalSetSaveHandler} overallPosition={"bottom"}/>}
        </div>

  );
};

export default MatrixBottomControlsRow;
